module.exports = __webpack_public_path__ + "img/Prometheus.a9d3b3fd.png";